import React from 'react';
import { toast } from 'react-toastify';
import Option from '../Option/Option';
import './Question.css';
import { AiFillEye } from "react-icons/ai";

const Question = ({ question, index }) => {
    const modifiedQuestion = question.question.slice(3);
    const finalModified = modifiedQuestion.slice(0, -4);
    // This is for show correct ans
    const correctAns = (correctAns) => {
        toast.info(`Ans is:-- ${correctAns}!`, { autoClose: 3000 })
    }

    return (
        <div className='w-[90%] mx-auto bg-purple-300 my-7 rounded-md p-5 relative'>
            <AiFillEye onClick={() => correctAns(question.correctAnswer)} className='absolute right-3 top-1 text-4xl hover:cursor-pointer text-blue-700'></AiFillEye>
            <h1 className='w-[80%] mx-auto text-xl'>{index + 1}:- {finalModified}</h1>
            {/* Options */}
            <div className='grid grid-cols-1 lg:grid-cols-2'>
                {question.options.map((option, inx) => <Option
                    option={option}
                    id={question.id}
                    key={inx}
                    ans={question.correctAnswer}
                ></Option>)}

            </div>
        </div>
    );
};

export default Question;